import React, { useState } from 'react';
import { Table as AntTable, Skeleton } from 'antd';
import './style.css';
const Table = ({ loading, dataSource, columns, totalLenght = 0, pagingation: { totalNumberOfRecords, perPageSize, page, handlePageChange, show = true }, ...props }) => {
  const [pageSize, setPageSize] = useState(perPageSize);
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
    if (handlePageChange) handlePageChange(page, pageSize);
  };
  return (
    <div className='custom-table'>
      <AntTable
        {...props}
        dataSource={
          loading
            ? [...Array(10)]?.map((_, index) => ({
                key: `key${index}`,
              }))
            : dataSource
        }
        columns={
          loading
            ? columns?.map((column) => {
                return {
                  ...column,
                  render: () => {
                    return <Skeleton active={true} paragraph={false} key={column?.key} />;
                  },
                };
              })
            : columns
        }
        pagination={
          show
            ? {
                showTotal: (total, range) => `Showing ${range[0]}-${range[1]} from ${totalLenght} items`,
                showSizeChanger: true,
                total: totalLenght,
                onChange: onPageChange,
                responsive: true,
                disabled: false,
                pageSize: pageSize,
                current: page ? page : currentPage,
                showQuickJumper: false,
              }
            : false
        }
        responsive={true}
      />
    </div>
  );
};
export default Table;
